/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Pick_DescriptionInputs */

const en_onboarding_v1_pick_description = /** @type {(inputs: Onboarding_V1_Pick_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick one and it runs itself from there.`)
};

const de_onboarding_v1_pick_description = /** @type {(inputs: Onboarding_V1_Pick_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eines aus – ab dann läuft es von selbst.`)
};

const pt_br2_onboarding_v1_pick_description = /** @type {(inputs: Onboarding_V1_Pick_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um e ele funciona sozinho a partir daí.`)
};

const tr_onboarding_v1_pick_description = /** @type {(inputs: Onboarding_V1_Pick_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Birini seçin, gerisini kendi kendine halletsin.`)
};

const zh_cn2_onboarding_v1_pick_description = /** @type {(inputs: Onboarding_V1_Pick_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一个，之后它会自动运行。`)
};

const zh_hk2_onboarding_v1_pick_description = /** @type {(inputs: Onboarding_V1_Pick_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇一個，之後它便會自動運作。`)
};

const ko_kr2_onboarding_v1_pick_description = /** @type {(inputs: Onboarding_V1_Pick_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`하나를 선택하면 그다음부터 자동으로 운용돼요.`)
};

const ru_ru2_onboarding_v1_pick_description = /** @type {(inputs: Onboarding_V1_Pick_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите один — дальше он будет работать сам.`)
};

const es_419_onboarding_v1_pick_description = /** @type {(inputs: Onboarding_V1_Pick_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige uno y, a partir de ahí, funcionará automáticamente.`)
};

/**
* | output |
* | --- |
* | "Pick one and it runs itself from there." |
*
* @param {Onboarding_V1_Pick_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_pick_description = /** @type {((inputs?: Onboarding_V1_Pick_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Pick_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_pick_description(inputs)
	if (locale === "de") return de_onboarding_v1_pick_description(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_pick_description(inputs)
	if (locale === "tr") return tr_onboarding_v1_pick_description(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_pick_description(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_pick_description(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_pick_description(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_pick_description(inputs)
	return es_419_onboarding_v1_pick_description(inputs)
});